module.exports = __webpack_public_path__ + "static/profile_alt-8161122261d7296e9095d03190235abe.jpg";